<template>
	<div>
		<div class="form-group row">
			<label for="" class="col-lg-3 col-form-label">Region</label>
			<div class="col-lg-4">
				<div 
					v-for="item in region.map(x => x.code)"
					:key="item"
					class="form-check form-check-inline"
					:id="'inputRadioRegion' + item">
					<input 
						class="form-check-input"
						type="radio" 
						:value="item" 
						v-model="form.region"
						@change="validateRequired">
					<label class="form-check-label" :for="'inputRadioRegion' + item">
						{{ item }}
					</label>
				</div>
			</div>
		</div>

		<div class="form-group row">
			<label for="" class="col-lg-3 col-form-label">Ekspedisi</label>
			<div class="col-lg-4">
				<multiselect
					v-model="form.ekspedisi"
					:options="ekspedisiOptions"
					label="name"
					track-by="id"
					placeholder="Select Ekspedisi"
					@input="validateRequired"
				></multiselect>
			</div>
		</div>

		<div class="form-group row">
			<label for="" class="col-lg-3 col-form-label">Nopol</label>
			<div class="col-lg-4">
				<input 
					class="form-control"
					type="text" 
					v-model="form.nopol"
					@input="validateRequired">
			</div>
		</div>

		<div class="form-group row">
			<label for="" class="col-lg-3 col-form-label">Odol</label>
			<div class="col-lg-4">
				<div class="form-check form-check-inline">
					<input type="radio" id="inputRadioOdolY" class="form-check-input"
						v-model="form.odol" value="Y" 
						@change="validateRequired">
					<label for="inputRadioOdolY" class="form-check-label">Yes</label>
				</div>
				<div class="form-check form-check-inline">
					<input type="radio" id="inputRadioOdolN" class="form-check-input"
						v-model="form.odol" value="N"
						@change="validateRequired">
					<label for="inputRadioOdolN" class="form-check-label">No</label>
				</div>
			</div>
		</div>

		<div class="form-group row">
			<label for="" class="col-lg-3 col-form-label">Kategori Truck</label>
			<div class="col-lg-4">
				<input
					type="text"
					v-model="form.kategori_truck"
					class="form-control"
					placeholder="Kategori Truck"
					@input="inputKategoriTruck"
				/>
			</div>
		</div>

		<div class="form-group row">
			<label for="" class="col-lg-3 col-form-label">Kapasitas Packing</label>
			<div class="col-lg-4">
				<input
					type="text"
					v-model="form.kapasitas_packing"
					class="form-control"
					placeholder="0"
					@input="inputKapasitasPacking"
				/>
			</div>
		</div>

		<div class="form-group row">
			<label for="" class="col-lg-3 col-form-label">Kapasitas Build-Up</label>
			<div class="col-lg-4">
				<input
					type="text"
					v-model="form.kapasitas_buildup"
					class="form-control"
					placeholder="0"
					@input="inputKapasitasBuildUp"
				/>
			</div>
		</div>

		<div class="d-flex justify-content-end mt-5">
			<button 
				type="button"
				class="btn btn-submit"
				:disabled="!isAllStep1Required"
				@click="nextPage">Selanjutnya</button>
		</div>
	</div>
</template>

<style scoped>
.form-group.row {
	align-items: center;
}
</style>

<script>
import Multiselect from "vue-multiselect";

export default {
    data() {
		//
		return {
			isAllStep1Required: false,
		}
	},
	components: {
		Multiselect,
	},
	mounted () {
		//
		this.validateRequired()
	},
	props: ['form', 'region', 'ekspedisiOptions'],
	created() {
		//
	},
	watch: {
		//
	},
	methods: {
		//
		inputKategoriTruck() {
			this.form.kategori_truck = this.form.kategori_truck.toUpperCase();
			this.validateRequired();
		},
		inputKapasitasPacking() {
			this.form.kapasitas_packing = this.form.kapasitas_packing.replace(/[^0-9]/g, "");
			this.validateRequired();

		},
		inputKapasitasBuildUp() {
			this.form.kapasitas_buildup = this.form.kapasitas_buildup.replace(/[^0-9]/g, "");
			this.validateRequired();
		},
		validateRequired() {
			if (this.form.region && 
				this.form.ekspedisi && 
				this.form.nopol && 
				this.form.odol && 
				this.form.kategori_truck && 
				this.form.kapasitas_packing &&
				this.form.kapasitas_buildup) {
				this.isAllStep1Required = true
			} else {
				this.isAllStep1Required = false
			}
			// console.log(this.form)
		},	
		nextPage() {
			this.$emit('nextPage');
		},
	},
};
</script>